import { Injectable } from '@angular/core';
import { global } from '../../models/global';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/add/Observable/throw';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import { DropDownRequest } from '../../Models/DropDwon/DropDownRequest';

@Injectable({
    providedIn: 'root'
})
export class DropDownService {
    getAnnualRequirementFilters() {
        throw new Error('Method not implemented.');
    }
    ROOT_URL: string = "";
    constructor(private http: Http) {
        let g: global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    getAllHierarchyDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetAllRoleWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getSBUHierarchyDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetSBUWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getDivisionHierarchyDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetDivisionWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getZoneHierarchyDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetZoneWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getSDDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetSD';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getWarehouseLocationDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetWHLocation';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getRegionWiseRMHDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetRegionWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getRMHWiseRegionDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetRMHWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getProductWiseCropDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetProductWiseCrop';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getCropWisePorductDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetCropWiseProduct';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getSDRMHWise(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetSDRMHWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getWHRMHWise(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetWHRMHWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }

    getAllHierarchyDemoSampleDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetAllRoleWiseNoRMH';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getSDRegionWise(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetSDRegionWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getRMHRoleId(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetRMHRoleId';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
    getWarehouseWiseRMHDropDown(ddlRequest: DropDownRequest): Observable<any> {
        let url = this.ROOT_URL + '/api/DropDown/GetWarehouseWise';
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
        let requestoptions: RequestOptions = new RequestOptions({
            method: 'POST',
            url: url,
            headers: headers,
            body: JSON.stringify(ddlRequest)
        })
        return this.http.request(new Request(requestoptions))
            .map(response => <any>(<Response>response).json());
    }
 
}